<script>
import Integer from "vuelidate/lib/validators/integer";
import QuestionTooltip from "@/components/app/policyReissue/components/QuestionTooltip.vue";
import FileInput from "@/components/app/policyReissue/components/FileInput.vue";
import displaySettings from "@/mixin/displaySettings";
import reissueTypes from "./index";

export default {
    name: "StandardPolicyReissue",
    components: {FileInput, QuestionTooltip,},
    model: {
        prop: 'dataForm',
        event: 'input',
    },
    props: {
        dataForm: {
            type: Object,
            default: function () {
                return {
                    reasonType: 1,
                    reason: null,
                    fileTech: null,
                    file: null,
                }
            }
        },
        companyName: {
            type: String,
            default: function () {
                return '';
            },
        },
        moduleId: {
            type: Number,
            default: function () {
                return '';
            }
        },
        productId: {
            type: Number,
            default: function () {
                return '';
            }
        },
        reasonTypes: {
            type: Array,
            default: function () {
                return [{
                    name: null,
                    id: null,
                }];
            },
        },
        additionalFields: {
            type: String,
            default: function () {
                return '';
            },
        },
        templateStatementPath: {
            type: Boolean,
            default: true,
        },
    },
    data() {
        return {
            reason: null,
            reasonType: null,
        }
    },
    watch: {
        dataForm: {
            handler: function (val) {
                let params = {
                    "reasonType" : val.reasonType,
                    "reason" : val.reason,
                    "file" : val.file,
                    "fileTech" : val.fileTech,
                    "email" : val.email ?? null,
                }
                this.$emit('is-fill-form', params);
            },
            deep: true
        }
    },
    mounted() {
        this.$emit('is-fill-form', true)
    },
    created() {

    },
}
</script>


<template>
    <div class="policy-reissue-custom">
        <question-tooltip>
            <div class="mt-2">
                <p>Особливості переоформлення договорів страхування:</p>
                <ol class="list-left" style="text-align: left; font-size: 12px;">
                    <li>Дозволено змінювати:
                        <ul>
                            <li>Номер авто.</li>
                            <li>VIN-код.</li>
                            <li>Одне з полів даних про клієнта (не у всіх СК).</li>
                        </ul>
                    </li>
                    <li>Не можна змінювати:
                        <ul>
                            <li>Марку/модель авто, рік випуску.</li>
                            <li>Місце реєстрації власника. У разі зміни реєстрації зверніться в чат Viber для консультації щодо довгострокового розірвання.</li>
                        </ul>
                    </li>
                    <li>Потрібно прикріпити заяву на переоформлення:
                        <ul>
                            <li>Інтер-Поліс, ІНГО, ЄСА.</li>
                        </ul>
                    </li>
                </ol>
            </div>
        </question-tooltip>
        <el-row>
            <el-col class="title mb-2">
                Для переоформлення полісу від {{ companyName }}, будь ласка, прикріпіть фото техпаспорту з обох сторін, заяву та вкажіть, які зміни необхідно внести в договір.
            </el-col>
            <el-col class="text-center mb-2">
                <u><el-link v-if="templateStatementPath" :href="'/api/download-reissue-statement-template/' + productId + '/' + moduleId" target="_blank" :underline="true" style="font-weight: bold">Завантажити шаблон заяви</el-link></u>
            </el-col>
            <el-col>
                <div class="form-group mb-1">
                    <div class="text-label mb-1">
                        Змінити:
                    </div>
                    <el-select
                        :max-height="120"
                        class="form-control-el"
                        placeholder="Оберіть дані для зміни"
                        v-model="dataForm.reasonType"
                    >
                        <el-option v-for="value in reasonTypes"
                                   :value="value.id"
                                   :key="value.key"
                                   :label="value.name">
                        </el-option>
                    </el-select>
                </div>
                <div class="form-group">
                    <div class="text-label mb-1">
                        Введіть оновлені дані:
                    </div>
                    <el-input placeholder="Наприклад, АХ6547КА" v-model="dataForm.reason"></el-input>
                </div>
            </el-col>
            <el-col class="mb-3">
                <file-input v-model="dataForm.fileTech" :title="'Прикріпити техпаспорт'"></file-input>
            </el-col>
            <!-- additional fields if ingo, Eia, Inter-Polis, Oranta -->
            <el-col v-if="additionalFields && additionalFields === 'file'" class="mb-4">
                <file-input v-model="dataForm.file"></file-input>
            </el-col>
            <el-col v-if="additionalFields && additionalFields === 'email'" class="mb-4">
                <div class="text-label mb-1">
                    Електронна пошта страхувальника:
                </div>
                <el-input placeholder="Наприклад, klient@ukasko.com.ua" type="email"
                          v-model="dataForm.email"></el-input>
            </el-col>

        </el-row>
    </div>
</template>

<style scoped>

</style>
